import React, { useState } from "react";
import {
    Popover,
    TextField,
} from "@mui/material";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import CustomButton from "../elements/CustomButton/CustomButton";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const SearchFilter = ({
    searchHandler,
    columnField,
    columnLabel,
    searchFilter,
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [searchText, setSearchText] = useState(searchFilter || "");

    const handleOpen = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleApply = () => {
        const value =
            columnField === "date" && searchText ? dayjs(searchText).format("YYYY-MM-DD") : searchText;
        searchHandler({ value, column: columnField });
        handleClose();
    };

    const handleClear = () => {
        setSearchText("");
        searchHandler({ value: "", column: columnField });
        handleClose();
    };

    return (
        <div>
            <div className="cursor-pointer ml-2" onClick={handleOpen}>
                <FilterListOutlinedIcon sx={{ fontSize: "18px" }} />
            </div>

            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
                style={{ marginLeft: "50px", marginTop: "10px" }}
            >
                <div className="p-4 min-w-[250px]">
                    {columnField === "date" ? (
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={searchText ? dayjs(searchText) : null}
                                onChange={(newValue) => setSearchText(newValue)}
                                format="YYYY-MM-DD"
                                slotProps={{
                                    textField: {
                                        size: "small",
                                        fullWidth: true,
                                        label: `Select ${columnLabel}`,
                                    },
                                }}
                            />
                        </LocalizationProvider>
                    ) : (
                        <TextField
                            label={`Search ${columnLabel}`}
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                        />
                    )}

                    <div className="flex items-center justify-center gap-2 mt-3">
                        <CustomButton
                            onClick={handleClear}
                            customeClass="primary-custom-button w-[80px] h-[30px]"
                        >
                            Reset
                        </CustomButton>
                        <CustomButton
                            onClick={handleApply}
                            customeClass="gradient-button w-[80px] h-[30px]"
                        >
                            Apply
                        </CustomButton>
                    </div>
                </div>
            </Popover>
        </div>
    );
};

export default SearchFilter;
